import React from 'react';
import { NamedLink } from '../../components';
import config from '../../config';

import BikeElectric from './bike_electric.webp';
import BikeGravel from './bike_gravel.webp';
import CampingTent from './camping_tent.webp';
import Sup from './sup.webp';
import Trailer from './trailer.avif';
import BikeMountain from './bike_mountain.webp';
import CampingAccessories from './camping_accessories.webp';
import Carrier from './carrier.png';
import Crampons from './crampons.webp';
import Snowshoes from './snowshoes.webp';
import Winter from './camping.png';
import Fitness from './fitness.avif';
import Ski from './ski.avif';
import Snowboard from './snowboard.avif';
import CrossCountry from './inovik.jpg';
import BikeRoad from './roadbike.avif';
import RoofTent from './rooftent.jpeg';
import BikeTreadmill from './bikes_treadmill.png';
import Transport from './transport.avif';
import Campers from './camper.png';
import SeasonalSki from './seasonalski.webp';
import IceSkates from './iceskates.png';
import SkiTour from './skitour.png';
import BikesTrekking from './trekkingBike.png';
import Kayak from './kayak_new.png';

import css from './LandingPage.css';

const SectionCategories = props => {
  const { intl } = props;

  const sportsData = [
    { img: BikeElectric, countries: ['pl', 'sk', 'cz', 'hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.bikeElectric' }), pageName: 'ElectricBikesSearchPage' },
    { img: BikeGravel, countries: ['pl', 'cz', 'sk', 'hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.bikeGravel' }), pageName: 'GravelBikesSearchPage' },
    { img: BikeMountain, countries: ['pl', 'cz', 'hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.bikeMountain' }), to: 'businessCategory=bikes_mountain&category=bikes&exact=true' },
    { img: BikeRoad, countries: ['pl', 'sk', 'cz', 'hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.bikeRoad' }), pageName: 'BikesRoadSearchPage' },
    { img: BikesTrekking, countries: ['pl', 'hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.bikeTrekking' }), to: 'businessCategory=bikes_trekking&category=bikes&exact=true' },
    { img: Trailer, countries: ['pl', 'sk'], name: intl.formatMessage({ id: 'LandingPage.sportsList.trailer' }), pageName: 'BikesTrailerSearchPage' },
    { img: Carrier, countries: ['pl', 'sk', 'cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.carrier' }), pageName: 'TourismCarrierSearchPage' },
    { img: BikeTreadmill, countries: ['pl'], name: intl.formatMessage({ id: 'LandingPage.sportsList.bikeTreadmill' }), to: 'businessCategory=bikes_treadmill&exact=true' },
    { img: Crampons, countries: ['pl'], name: intl.formatMessage({ id: 'LandingPage.sportsList.crampons' }), pageName: 'TourismCramponsSearchPage' },
    { img: Fitness, countries: ['cz', 'pl'], name: intl.formatMessage({ id: 'LandingPage.sportsList.fitness' }), to: 'businessCategory=fitness_cardio&category=fitness&exact=true' },
    { img: CampingTent, countries: ['cz', 'hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.campingTent' }), pageName: 'CampingTentSearchPage' },
    { img: RoofTent, countries: ['cz', 'sk', 'hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.campingRoofTent' }), pageName: 'CampingRoofTentSearchPage' },
    // { img: Ski, countries: ['hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.ski' }), to: 'businessCategory=wintersports_alpineskiing&category=wintersports&exact=true', pageName: 'AlpineSkiingSearchPage' },
    // { img: SeasonalSki, countries: ['cz', 'sk'], name: intl.formatMessage({ id: 'LandingPage.sportsList.seasonalski' }), pageName: 'SeasonalSkiSearchPage' },
    // { img: SkiTour, countries: ['sk'], name: intl.formatMessage({ id: 'LandingPage.sportsList.skitour' }), pageName: 'SkiTouringSearchPage' },
    // { img: CrossCountry, countries: ['cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.crossCountry' }), pageName: 'WintersportsCrosscountrySearchPage' },
    // { img: Snowboard, countries: ['hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.snowboard' }), to: 'businessCategory=wintersports_snowboard&category=wintersports&exact=true', pageName: 'WintersportsSnowboardSearchPage' },
    { img: IceSkates, countries: ['cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.wintersportsOther' }), pageName: 'WintersportsOtherSearchPage' },
    // { img: Snowshoes, countries: ['cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.snowshoes' }), to: 'businessCategory=tourism_snowshoes&category=tourism&exact=true' },
    // { img: Crampons, countries: ['cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.crampons' }), pageName: 'TourismCramponsSearchPage' },
    // { img: CampingTent, countries: ['pl'], name: intl.formatMessage({ id: 'LandingPage.sportsList.campingTent' }), pageName: 'CampingTentSearchPage' },
    { img: CampingAccessories, countries: ['cz', 'hu'], name: intl.formatMessage({ id: 'LandingPage.sportsList.campingAccessories' }), pageName: 'CampingAccessoriesSearchPage' },
    { img: Sup, countries: ['sk', 'hu', 'cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.sup' }), pageName: 'WatersportsSupSearchPage' },
    // { img: Kayak, countries: ['hu','cz', 'sk'], name: intl.formatMessage({ id: 'LandingPage.sportsList.kayak' }), pageName: 'WatersportsKayakSearchPage'  },
    // { img: CrossCountry, countries: ['cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.crossCountry' }), to: 'businessCategory=wintersports_crosscountry&category=wintersports&exact=true' },
    // { img: Snowboard, countries: ['cz', 'hu', 'pl'], name: intl.formatMessage({ id: 'LandingPage.sportsList.snowboard' }), to: 'businessCategory=wintersports_snowboard&category=wintersports&exact=true' },
    // { img: IceSkates, countries: ['cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.wintersportsOther' }), to: 'businessCategory=wintersports_other&category=wintersports&exact=true' },
    // { img: Snowshoes, countries: ['cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.snowshoes' }), to: 'businessCategory=tourism_snowshoes&category=tourism&exact=true' },
    { img: Ski, countries: ['pl'], name: intl.formatMessage({ id: 'LandingPage.sportsList.ski' }), to: 'businessCategory=wintersports_alpineskiing&category=wintersports&exact=true' },
    // { img: Snowboard, countries: ['pl'], name: intl.formatMessage({ id: 'LandingPage.sportsList.snowboard' }), to: 'businessCategory=wintersports_snowboard&category=wintersports&exact=true' }
    // { img: Fitness, countries: ['cz'], name: intl.formatMessage({ id: 'LandingPage.sportsList.fitness' }), to: 'businessCategory=fitness_cardio&category=fitness&exact=true' },
    // { img: Transport, countries: ['pl'], name: intl.formatMessage({ id: 'LandingPage.sportsList.transport' }), to: 'businessCategory=transport_bikes&category=transport&exact=true' },
    // { img: Campers, countries: ['pl'], name: intl.formatMessage({ id: 'LandingPage.sportsList.camper' }), to: 'businessCategory=camping_campers&exact=true&category=camping' },
  ];

  return (
    <div className={css.sportsList}>
      <ul>
        {sportsData.filter(cat => {
          return cat.countries.length === 0 || cat.countries.includes(config.custom.countryId);
        }).map(({ img, name, to, pageName }, key) => (
          <li key={key}>
            <NamedLink
              name={pageName || "SearchPage"}
              to={pageName ? undefined : {
                search: to,
              }}
            >
              <img src={img} alt={name} />
              <h2>{name}</h2>
            </NamedLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SectionCategories;
